export enum AdxAlertType {
    ABOVE = "ABOVE",
    BELOW = "BELOW"
}
